import React, { useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCartData,
  removeFromCarts,
  updateCartQuantity,
} from "../../../ReduxSlice/BookSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CartPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cartItems = useSelector(selectCartData);

  // Input states
  const [discountType, setDiscountType] = useState("percent"); // percent | flat
  const [discountValue, setDiscountValue] = useState(0);

  // Applied discount states (only updated on "Apply")
  const [appliedDiscountValue, setAppliedDiscountValue] = useState(0);
  const [appliedDiscountType, setAppliedDiscountType] = useState("percent");

  /* 🧮 Subtotal */
  const subtotal = useMemo(() => {
    return cartItems.reduce(
      (sum, item) => sum + item.withoutDiscountPrice * item.quantity,
      0
    );
  }, [cartItems]);

  /* 🧮 Discount Amount */
  const discountAmount = useMemo(() => {
    if (!appliedDiscountValue) return 0;

    if (appliedDiscountType === "percent") {
      return (subtotal * appliedDiscountValue) / 100;
    }

    return Number(appliedDiscountValue); // flat ₹
  }, [appliedDiscountValue, appliedDiscountType, subtotal]);

  /* 🧮 Final Total */
  const finalTotal = useMemo(() => {
    return subtotal - discountAmount;
  }, [subtotal, discountAmount]);

  const isDiscountApplied = appliedDiscountValue > 0;

  /* ================= ACTIONS ================= */

  const updateQty = (id, qty) => {
    if (qty < 1) return;
    dispatch(updateCartQuantity({ bookId: id, newQuantity: qty }));
  };

  const removeItem = (id) => {
    dispatch(removeFromCarts(id));
    toast.error("Item removed from cart");
  };

  const applyDiscount = () => {
    if (!discountValue || discountValue <= 0) return;

    setAppliedDiscountValue(Number(discountValue));
    setAppliedDiscountType(discountType);
    toast.success("Discount applied");
  };

  const removeDiscount = () => {
    setAppliedDiscountValue(0);
    setAppliedDiscountType("percent");
    setDiscountValue(0);
    toast.info("Discount removed");
  };

  const handleCheckout = () => {
    if (!cartItems.length) {
      toast.error("Your cart is empty");
      return;
    }

    navigate("/pos/checkout", {
      state: {
        cartItems,
        total: finalTotal,
      },
    });
  };

  /* ================= UI ================= */

  return (
    // <div className="min-h-screen bg-gray-100 flex flex-col">
    //   {/* Header */}
    //   <div className="sticky top-0 bg-white border-b z-20 p-4 font-semibold text-lg">
    //     My Cart ({cartItems.length})
    //   </div>

    //   {/* Cart Items */}
    //   <div className="flex-1 overflow-y-auto px-3 pb-40">
    //     {cartItems.map((item) => (
    //       <div
    //         key={item.id}
    //         className="bg-white rounded-xl p-3 mb-3 shadow-sm flex gap-3"
    //       >
    //         <img
    //           src={item.image}
    //           alt={item.name}
    //           className="w-20 h-20 rounded-lg object-cover"
    //         />

    //         <div className="flex-1">
    //           <h3 className="text-sm font-semibold">{item.name}</h3>

    //           <p className="text-green-600 font-bold mt-1">
    //             ₹{(item.withoutDiscountPrice * item.quantity).toFixed(2)}
    //           </p>

    //           <div className="flex justify-between items-center mt-3">
    //             {/* Qty */}
    //             <div className="flex items-center border rounded-lg overflow-hidden">
    //               <button
    //                 onClick={() => updateQty(item.id, item.quantity - 1)}
    //                 className="px-3 py-1 text-lg"
    //               >
    //                 −
    //               </button>
    //               <span className="px-3 text-sm">{item.quantity}</span>
    //               <button
    //                 onClick={() => updateQty(item.id, item.quantity + 1)}
    //                 className="px-3 py-1 text-lg"
    //               >
    //                 +
    //               </button>
    //             </div>

    //             {/* Remove */}
    //             <button
    //               onClick={() => removeItem(item.id)}
    //               className="text-red-500 text-xs font-medium"
    //             >
    //               Remove
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     ))}

    //     {/* Discount */}
    //     <div className="bg-white rounded-xl p-4 shadow-sm mt-4">
    //       <p className="font-medium mb-2">Apply Discount</p>

    //       <div className="flex gap-2">
    //         <select
    //           value={discountType}
    //           disabled={isDiscountApplied}
    //           onChange={(e) => setDiscountType(e.target.value)}
    //           className="border rounded-lg px-2"
    //         >
    //           <option value="percent">%</option>
    //           <option value="flat">₹</option>
    //         </select>

    //         <input
    //           type="number"
    //           min="0"
    //           disabled={isDiscountApplied}
    //           className="flex-1 border rounded-lg px-3 py-2 disabled:bg-gray-100"
    //           placeholder={
    //             discountType === "percent"
    //               ? "Enter % discount"
    //               : "Enter flat ₹ discount"
    //           }
    //           value={discountValue}
    //           onChange={(e) => setDiscountValue(e.target.value)}
    //         />

    //         {!isDiscountApplied ? (
    //           <button
    //             onClick={applyDiscount}
    //             className="bg-blue-600 text-white px-4 rounded-lg"
    //           >
    //             Apply
    //           </button>
    //         ) : (
    //           <button
    //             onClick={removeDiscount}
    //             className="bg-red-500 text-white px-4 rounded-lg"
    //           >
    //             Remove
    //           </button>
    //         )}
    //       </div>
    //     </div>

    //     {/* Summary */}
    //     <div className="bg-white rounded-xl p-4 shadow-sm mt-4">
    //       <div className="flex justify-between text-sm">
    //         <span>Subtotal</span>
    //         <span>₹{subtotal.toFixed(2)}</span>
    //       </div>

    //       <div className="flex justify-between text-sm mt-2">
    //         <span>Discount</span>
    //         <span>₹{discountAmount.toFixed(2)}</span>
    //       </div>

    //       <div className="flex justify-between font-bold text-lg mt-3">
    //         <span>Total</span>
    //         <span>₹{finalTotal.toFixed(2)}</span>
    //       </div>
    //     </div>
    //   </div>

    //   {/* Bottom Bar */}
    //   <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 flex justify-between items-center shadow-lg">
    //     <div>
    //       <p className="text-xs text-gray-500">Payable Amount</p>
    //       <p className="text-lg font-bold text-green-600">
    //         ₹{finalTotal.toFixed(2)}
    //       </p>
    //     </div>

    //     <button
    //       onClick={handleCheckout}
    //       className="bg-yellow-400 px-6 py-3 rounded-xl font-semibold"
    //     >
    //       Checkout
    //     </button>
    //   </div>
    // </div>
    <div className="min-h-screen bg-gray-100 flex flex-col">
  {/* Header */}
  <div className="sticky top-0 bg-white border-b z-20 mb-2 px-4 py-3 text-base sm:text-lg font-semibold">
    My Cart ({cartItems.length})
  </div>

  {/* Cart Items */}
  <div className="flex-1 overflow-y-auto px-3 sm:px-6 pb-44">
    {cartItems.map((item) => (
      <div
        key={item.id}
        className="bg-white rounded-xl p-3 sm:p-4 mb-3 shadow-sm flex gap-3"
      >
        <img
          src={item.image}
          alt={item.name}
          className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg object-cover"
        />

        <div className="flex-1">
          <h3 className="text-sm sm:text-base font-semibold line-clamp-2">
            {item.name}
          </h3>

          <p className="text-green-600 font-bold mt-1 text-sm sm:text-base">
            ₹{(item.withoutDiscountPrice * item.quantity).toFixed(2)}
          </p>

          <div className="flex justify-between items-center mt-3">
            {/* Qty */}
            <div className="flex items-center border rounded-lg overflow-hidden">
              <button
                onClick={() => updateQty(item.id, item.quantity - 1)}
                className="px-3 py-1 text-lg"
              >
                −
              </button>
              <span className="px-3 text-sm sm:text-base">
                {item.quantity}
              </span>
              <button
                onClick={() => updateQty(item.id, item.quantity + 1)}
                className="px-3 py-1 text-lg"
              >
                +
              </button>
            </div>

            {/* Remove */}
            <button
              onClick={() => removeItem(item.id)}
              className="text-red-500 text-xs sm:text-sm font-medium"
            >
              Remove
            </button>
          </div>
        </div>
      </div>
    ))}

    {/* Discount */}
    <div className="bg-white rounded-xl p-4 shadow-sm mt-4">
      <p className="font-medium mb-2 text-sm sm:text-base">Apply Discount</p>

      <div className="flex flex-col sm:flex-row gap-2">
        <div className="flex gap-2 w-full">
          <select
            value={discountType}
            disabled={isDiscountApplied}
            onChange={(e) => setDiscountType(e.target.value)}
            className="border rounded-lg px-2 py-2 text-sm"
          >
            <option value="percent">%</option>
            <option value="flat">₹</option>
          </select>

          <input
            type="number"
            min="0"
            disabled={isDiscountApplied}
            className="flex-1 border rounded-lg px-3 py-2 text-sm disabled:bg-gray-100"
            placeholder={
              discountType === "percent"
                ? "Enter % discount"
                : "Enter flat ₹ discount"
            }
            value={discountValue}
            onChange={(e) => setDiscountValue(e.target.value)}
          />
        </div>

        {!isDiscountApplied ? (
          <button
            onClick={applyDiscount}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm w-full sm:w-auto"
          >
            Apply
          </button>
        ) : (
          <button
            onClick={removeDiscount}
            className="bg-red-500 text-white px-4 py-2 rounded-lg text-sm w-full sm:w-auto"
          >
            Remove
          </button>
        )}
      </div>
    </div>

    {/* Summary */}
    <div className="bg-white rounded-xl p-4 shadow-sm mt-4 text-sm sm:text-base">
      <div className="flex justify-between">
        <span>Subtotal</span>
        <span>₹{subtotal.toFixed(2)}</span>
      </div>

      <div className="flex justify-between mt-2">
        <span>Discount</span>
        <span>₹{discountAmount.toFixed(2)}</span>
      </div>

      <div className="flex justify-between font-bold text-lg mt-3">
        <span>Total</span>
        <span>₹{finalTotal.toFixed(2)}</span>
      </div>
    </div>
  </div>

  {/* Bottom Bar */}
  <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 flex justify-between items-center shadow-lg">
    <div>
      <p className="text-xs text-gray-500">Payable Amount</p>
      <p className="text-lg sm:text-xl font-bold text-green-600">
        ₹{finalTotal.toFixed(2)}
      </p>
    </div>

    <button
      onClick={handleCheckout}
      className="bg-yellow-400 px-5 sm:px-6 py-3 rounded-xl font-semibold text-sm sm:text-base"
    >
      Checkout
    </button>
  </div>
</div>

  );
};

export default CartPage;


// import React, { useMemo, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   selectCartData,
//   removeFromCarts,
//   updateCartQuantity,
//   totalPrice,
//   selecteDiscount,
//   witoutDiscoutTotalPrice,
// } from "../../../ReduxSlice/BookSlice";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// const CartPage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const cartItems = useSelector(selectCartData);
//   const reduxDiscount = useSelector(selecteDiscount);
//   const totalAmount = useSelector(witoutDiscoutTotalPrice);

//   const [discountValue, setDiscountValue] = useState(reduxDiscount || "");
//   const isDiscountApplied = reduxDiscount > 0;

//   /* 🧮 Subtotal (no state needed) */
//   const subtotal = useMemo(() => {
//     return cartItems.reduce(
//       (sum, item) => sum + item.withoutDiscountPrice * item.quantity,
//       0
//     );
//   }, [cartItems]);

//   /* ================= ACTIONS ================= */

//   const updateQty = (id, qty) => {
//     if (qty < 1) return;
//     dispatch(updateCartQuantity({ bookId: id, newQuantity: qty }));
//   };

//   const removeItem = (id) => {
//     dispatch(removeFromCarts(id));
//     toast.error("Item removed from cart");
//   };

//   const applyDiscount = () => {
//     if (!discountValue || discountValue <= 0) return;
//     dispatch(totalPrice(Number(discountValue)));
//     toast.success("Discount applied");
//   };

//   const removeDiscount = () => {
//     dispatch(totalPrice(0));
//     setDiscountValue("");
//     toast.info("Discount removed");
//   };

//   const handleCheckout = () => {
//     if (!cartItems.length) {
//       toast.error("Your cart is empty");
//       return;
//     }

//     navigate("/pos/checkout", {
//       state: {
//         cartItems,
//         total: totalAmount,
//       },
//     });
//   };

//   /* ================= UI ================= */

//   return (
//     <div className="min-h-screen bg-gray-100 flex flex-col">
//       {/* Header */}
//       <div className="sticky top-0 bg-white border-b z-20 p-4 font-semibold text-lg">
//         My Cart ({cartItems.length})
//       </div>

//       {/* Cart Items */}
//       <div className="flex-1 overflow-y-auto px-3 pb-40">
//         {cartItems.map((item) => (
//           <div
//             key={item.id}
//             className="bg-white rounded-xl p-3 mb-3 shadow-sm flex gap-3"
//           >
//             <img
//               src={item.image}
//               alt={item.name}
//               className="w-20 h-20 rounded-lg object-cover"
//             />

//             <div className="flex-1">
//               <h3 className="text-sm font-semibold">{item.name}</h3>

//               <p className="text-green-600 font-bold mt-1">
//                 ₹{item.withoutDiscountPrice * item.quantity}
//               </p>

//               <div className="flex justify-between items-center mt-3">
//                 {/* Qty */}
//                 <div className="flex items-center border rounded-lg overflow-hidden">
//                   <button
//                     onClick={() => updateQty(item.id, item.quantity - 1)}
//                     className="px-3 py-1 text-lg"
//                   >
//                     −
//                   </button>
//                   <span className="px-3 text-sm">{item.quantity}</span>
//                   <button
//                     onClick={() => updateQty(item.id, item.quantity + 1)}
//                     className="px-3 py-1 text-lg"
//                   >
//                     +
//                   </button>
//                 </div>

//                 {/* Remove */}
//                 <button
//                   onClick={() => removeItem(item.id)}
//                   className="text-red-500 text-xs font-medium"
//                 >
//                   Remove
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}

//         {/* Discount */}
//         <div className="bg-white rounded-xl p-4 shadow-sm mt-4">
//           <p className="font-medium mb-2">Apply Discount (%)</p>

//           <div className="flex gap-2">
//             <input
//               type="number"
//               inputMode="numeric"
//               min="0"
//               max="100"
//               disabled={isDiscountApplied}
//               className="flex-1 border rounded-lg px-3 py-2 disabled:bg-gray-100"
//               placeholder="Enter discount"
//               value={discountValue}
//               onChange={(e) => setDiscountValue(e.target.value)}
//               onKeyDown={(e) =>
//                 ["-", "+", "e", "E"].includes(e.key) && e.preventDefault()
//               }
//             />

//             {!isDiscountApplied ? (
//               <button
//                 onClick={applyDiscount}
//                 className="bg-blue-600 text-white px-4 rounded-lg"
//               >
//                 Apply
//               </button>
//             ) : (
//               <button
//                 onClick={removeDiscount}
//                 className="bg-red-500 text-white px-4 rounded-lg"
//               >
//                 Remove
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Summary */}
//         <div className="bg-white rounded-xl p-4 shadow-sm mt-4">
//           <div className="flex justify-between text-sm">
//             <span>Subtotal</span>
//             <span>₹{subtotal}</span>
//           </div>

//           <div className="flex justify-between text-sm mt-2">
//             <span>Discount</span>
//             <span>{reduxDiscount}%</span>
//           </div>

//           <div className="flex justify-between font-bold text-lg mt-3">
//             <span>Total</span>
//             <span>₹{totalAmount.toFixed(2)}</span>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Bar */}
//       <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 flex justify-between items-center shadow-lg">
//         <div>
//           <p className="text-xs text-gray-500">Payable Amount</p>
//           <p className="text-lg font-bold text-green-600">
//             ₹{totalAmount.toFixed(2)}
//           </p>
//         </div>

//         <button
//           onClick={handleCheckout}
//           className="bg-yellow-400 px-6 py-3 rounded-xl font-semibold"
//         >
//           Checkout
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CartPage;
